import React from "react";
import { Card, CardBody, Row, Col, Table, Button } from "reactstrap";

const InLive = () => {
  // Dummy live battle data
  const battles = [
    {
      id: "LB001",
      battleName: "Battle Royale",
      battleType: "Solo",
      amount: 10,
      packData: "Starter Pack",
    },
    {
      id: "LB002",
      battleName: "War Zone",
      battleType: "Duo",
      amount: 25,
      packData: "Silver Pack",
    },
    {
      id: "LB003",
      battleName: "Clash Arena",
      battleType: "Squad",
      amount: 50,
      packData: "Gold Pack",
    },
  ];

  return (
    <div className="page-content">
      <Card className="mb-4">
        <CardBody>
          <Row className="mb-3">
            <Col md={6}>
              <h4 className="card-title">Live Battles</h4>
            </Col>
            <Col md={6} className="text-end">
              <Button color="primary">Add Battle</Button>
            </Col>
          </Row>

          <div className="table-responsive">
            <Table className="table table-nowrap mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Battle Details</th>
                  <th>Amount ($)</th>
                  <th>Pack Datas</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {battles.map((battle, index) => (
                  <tr key={battle.id}>
                    <td>{index + 1}</td>
                    <td>
                      <div>
                        <strong>{battle.battleName}</strong>
                        <br />
                        <small className="text-muted">
                          Type: {battle.battleType}
                        </small>
                      </div>
                    </td>
                    <td>{battle.amount}</td>
                    <td>{battle.packData}</td>
                    <td>
                      <Button color="info" size="sm" className="me-2">
                        View
                      </Button>
                      <Button color="danger" size="sm">
                        End
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default InLive;
